<template>
    <div class="container-fluid">
        <section class="content-header">
                <div class="row mb-2">
                    <h3>{{ $t('general.listadoproveedores') }}</h3>
                </div>
        </section>
        <section class="content">
            <div class="row">
                <div class="col-md-2">
                    <proveedores-estados :activos="activos" :eliminados="eliminados"/>
                </div>
                <div class="col-md-10">
                    <tabla-datos 
                        v-if="mostrareliminados==false && permisoscargados"
                        :columnas="columnas" 
                        :datos="proveedores"
                        :filtros="filtros" 
                        :filtrosBuscador="filtrosBuscador" 
                        @quieroDatos="obtenerProveedores($event)" 
                        :total="total"
                    ></tabla-datos>
                    <tabla-datos 
                        v-if="mostrareliminados==true && permisoscargados"
                        :columnas="columnasdos" 
                        :datos="proveedoreseliminados"
                        :filtros="filtrosdos" 
                        :filtrosBuscador="filtrosBuscadordos" 
                        @quieroDatos="obtenerEliminados($event)" 
                        :total="total"
                    ></tabla-datos>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import ProveedoresEstados from './listado/ProveedoresEstados.vue'
import TablaDatos from '../../TablaDatos.vue';
import { PwgsApi } from '../../../services/PwgsApi';
import { FilterMatchMode } from 'primevue/api';
export default {
    components: {
        'proveedores-estados': ProveedoresEstados,
        'tabla-datos': TablaDatos,
    },
    props: {
        id: {
            type: Number,
            default: 0,
        }
    },
data() {
        return {
            eliminados:'',
            activos:'',
            mostrareliminados: false,
            permisoscargados:false,
            permisomodif:false,
            proveedores: [],
            proveedoreseliminados: [],
            eliminado: false,
            parametros: null, // query params de DataTable
            filtrosBuscador: ['nombre_proveedor'], // filtros para el buscador
            filtros: { // filtros de columna
                'nombre_proveedor': { value: '', matchMode: FilterMatchMode.CONTAINS },
            },
            filtrosBuscadordos: ['nombre_proveedor'], // filtros para el buscador
            filtrosdos: { // filtros de columna
                'nombre_proveedor': { value: '', matchMode: FilterMatchMode.CONTAINS },
            },
            columnas: [
                {
                    header: 'Nombre',
                    field: 'nombre_proveedor',
                    sortable: true,
                    acciones: [
                        {
                            link: true,
                            tipo: 'default',
                            nombreId: 'id_proveedor',
                            // Debe ser arrow function para que this sea este componente
                            accion: (id) => {
                                this.$router.push({
                                    name: 'Proveedor',
                                    params: {
                                        id:id
                                    }
                                });
                            }
                        },
                    ]
                },
                {
                    header: 'Acciones',
                    data: null,
                    acciones: [
                        {
                            nombre: 'Editar',
                            class: 'editar',
                            tipo: 'default',
                            nombreId: 'id_proveedor',
                            icono: 'far fa-edit',
                            // Debe ser arrow function para que this sea este componente
                            accion: (id) => {
                                //this.obtenerUsuario(id);
                                this.$router.push({
                                    name: 'Proveedor',
                                    params: {
                                        id:id
                                    }
                                });
                            }
                        },                        
                    ]
                }
            ],
            columnasdos: [
                {
                    header: 'Nombre',
                    field: 'nombre_proveedor',
                    sortable: true,
                },
               
                {
                    header: 'Acciones',
                    data: null,
                    sortable:false,
                    acciones: [
                        {
                            nombre: 'Editar',
                            class: 'editar',
                            tipo: 'default',
                            nombreId: 'id_proveedor',
                            icono: 'far fa-edit',
                            // Debe ser arrow function para que this sea este componente
                            accion: (id) => {
                                this.$router.push({
                                    name: 'Proveedor',
                                    params: {
                                        id
                                    }
                                });
                            }
                        },
                     
                        
                    ]
                }
            ],
        }
    },
    methods: {
        cambiaractivos() {
            this.mostrareliminados = false;
        },
        cambiareliminados() {
            this.mostrareliminados = true;
        },
        async recuperar(id) {
            //PUT  modulos/pwgsapi/index.php/operarios/:id
            const api = new PwgsApi();
            let subidadatos = { estado_proveedor: "" };
            await api.put('proveedores/' + id, subidadatos);
            this.obtenerProveedores();
            this.cambiaractivos();
        },
        async obtenerProveedores(parametros) {
            /* get  modulos/pwgsapi/index.php/proveedores */
            const api = new PwgsApi();
            const params = parametros;
            this.$store.dispatch('cambiarCargando', true);
            const datos = await api.get('proveedores', params);
            this.proveedores = datos.datos;  
            this.total = datos.n_total_registros;
            this.activos = this.total;
            this.eliminado = false;
            this.columnas[0].header = this.$t("general.nombre");
            this.columnas[1].header = this.$t("general.acciones");
            this.$store.dispatch('cambiarCargando', false);     
        },
        async obtenerEliminados(parametros) {
            let params = parametros;
            const api = new PwgsApi();
            const datos = await api.get('proveedores/eliminados',params);
            this.eliminados = datos.n_total_registros;
            this.proveedoreseliminados = datos.datos;
        },
        async eliminar(id) {
            /* delete  modulos/pwgsapi/index.php/proveedores/:id */
            const api = new PwgsApi;
            await api.delete('proveedores/' + id);
            this.obtenerProveedores();
        },
        async comprobarPermisos(){
            const api = new PwgsApi();
            const modificar = await api.get('operarios/permiso-modificar');
            if(modificar == 1){
                this.permisomodif = true;
            }
            if(modificar == 1){
                this.permisomodif = true;
            }else{
                this.permisomodif = false;
            }
            if(this.permisomodif){
                let nuevo = {
                    nombre: 'Eliminar',
                    class: 'eliminar',
                    tipo: 'danger',
                    nombreId: 'id_proveedor',
                    icono: 'far fa-trash-alt',
                    // Debe ser arrow function para que this sea este componente
                    accion: (id) => {
                        if (confirm('Desea eliminar el proveedor')) {
                            this.eliminar(id);
                        }
                    }
                };
                this.columnas[1].acciones.push(nuevo);
                let nuevo2 = {
                    nombre: 'Recuperar',
                    class: 'recuperar',
                    tipo: 'success',
                    nombreId: 'id_proveedor',
                    icono: 'fa fa-recycle',
                    // Debe ser arrow function para que this sea este componente
                    accion: (id) => {
                        if (confirm('¿Desea recuperar al proveedor?')) {
                            this.recuperar(id);
                        }
                    }
                };
                this.columnasdos[1].acciones.push(nuevo2);
            }
            this.permisoscargados = true;
            console.log('PERMISO_MOD1',this.permisomodif);
        },
    },
    watch: {
        eliminado() {
            this.obtenerProveedores(this.parametros);
        }
    },
    activated() {
        this.eliminado = false;
        this.obtenerProveedores(this.parametros);
        this.obtenerEliminados(this.parametros);
    },
    mounted() {
        this.eliminado = false;
        this.obtenerProveedores(this.parametros);
        this.obtenerEliminados(this.parametros);
        this.comprobarPermisos();
    },
}
</script>
<style>
.p-dialog {
    width: 90%;
}
</style>